type GameId =
  | 'first-encounter'
  | 'scout-trainer'
  | 'word-wheel'
  | 'shape-shooter'
  | 'the-hideout'
  | 'short-circuit'
  | 'the-decoder'
  | 'master-thief'
  | 'sweet-sampler'
  | 'puzzle-train';

type GameName =
  | 'FirstEncounter'
  | 'ScoutTrainer'
  | 'WordWheel'
  | 'ShapeShooter'
  | 'Hideout'
  | 'ShortCircuit'
  | 'TheDecoder'
  | 'MasterThief'
  | 'SweetSampler'
  | 'PuzzleTrain';

export const gameIdMap: Record<GameId, GameName> = {
  'first-encounter': 'FirstEncounter',
  'scout-trainer': 'ScoutTrainer',
  'word-wheel': 'WordWheel',
  'shape-shooter': 'ShapeShooter',
  'the-hideout': 'Hideout',
  'short-circuit': 'ShortCircuit',
  'the-decoder': 'TheDecoder',
  'master-thief': 'MasterThief',
  'sweet-sampler': 'SweetSampler',
  'puzzle-train': 'PuzzleTrain',
};
